import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Delete, Visibility, ArrowBack } from '@mui/icons-material';
import api from '../../services/api';

const ShopDirectOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/shop/direct-orders');
      // Sort by billNumber in ascending order (as numbers)
      const sortedOrders = res.data.sort((a, b) => {
        const numA = parseInt(a.billNumber) || 0;
        const numB = parseInt(b.billNumber) || 0;
        return numA - numB;
      });
      setOrders(sortedOrders);
    } catch (err) {
      setError('Failed to fetch direct orders');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleView = (order) => {
    setSelectedOrder(order);
    setViewOpen(true);
  };
  
  const handleCloseView = () => {
    setViewOpen(false);
    setSelectedOrder(null);
  };
  
  const handleDelete = async (orderId) => {
    if (!window.confirm('Are you sure you want to delete this direct order?')) return;
    try {
      await api.delete(`/api/shop/direct-orders/${orderId}`);
      fetchOrders();
    } catch (err) {
      setError('Failed to delete direct order');
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Button startIcon={<ArrowBack />} onClick={() => window.history.back()} variant="outlined" color="primary">Back</Button>
        </Box>
        <Typography variant="h4" gutterBottom color="primary">
          Shop Direct Order List
        </Typography>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Bill Number</TableCell>
                  <TableCell>Order Date</TableCell>
                  <TableCell>Delivery Date</TableCell>
                  <TableCell>Required Date</TableCell>
                  <TableCell>Salesman</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders.map(order => (
                  <TableRow key={order._id}>
                    <TableCell>{order.billNumber}</TableCell>
                    <TableCell>{order.orderDate ? new Date(order.orderDate).toLocaleDateString() : ''}</TableCell>
                    <TableCell>{order.deliveryDate ? new Date(order.deliveryDate).toLocaleDateString() : ''}</TableCell>
                    <TableCell>{order.requiredDate ? new Date(order.requiredDate).toLocaleDateString() : ''}</TableCell>
                    <TableCell>{order.agentName}</TableCell>
                    <TableCell>{order.status}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleView(order)}><Visibility /></IconButton>
                      <IconButton onClick={() => handleDelete(order._id)}><Delete /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Dialog open={viewOpen} onClose={handleCloseView} maxWidth="md" fullWidth>
          <DialogTitle>Direct Order Details</DialogTitle>
          <DialogContent>
            {selectedOrder && (
              <Box>
                <Typography variant="subtitle1">Bill Number: {selectedOrder.billNumber}</Typography>
                <Typography variant="subtitle1">Order Date: {selectedOrder.orderDate ? new Date(selectedOrder.orderDate).toLocaleDateString() : ''}</Typography>
                <Typography variant="subtitle1">Delivery Date: {selectedOrder.deliveryDate ? new Date(selectedOrder.deliveryDate).toLocaleDateString() : ''}</Typography>
                <Typography variant="subtitle1">Required Date: {selectedOrder.requiredDate ? new Date(selectedOrder.requiredDate).toLocaleDateString() : ''}</Typography>
                <Typography variant="subtitle1">Salesman: {selectedOrder.agentName}</Typography>
                <Typography variant="subtitle1">Status: {selectedOrder.status}</Typography>
                <Typography variant="subtitle1">Items:</Typography>
                <ul>
                  {selectedOrder.items.map((item, idx) => (
                    <li key={idx}>{item.itemName} ({item.karat}) - Qty: {item.quantity}, Weight: {item.itemWeight}</li>
                  ))}
                </ul>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseView}>Close</Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  );
};

export default ShopDirectOrderList; 